import styles from './Dashboard.module.css';
import '../../resources/css/admin_style.css';
import React, {useEffect, useRef, useState} from "react";
import Loading from "../../utils/loading/Loading";
import Header from '../Header/Header';
import {IAM_SERVER_DASHBOARD, USER_SERVER_DASHBOARD_CHART, USER_SERVER_IDENTITY} from "../../utils/Config";
import axios from "../../utils/api/axios";
import {CircularProgress} from "@mui/material";
import {Doughnut, Line} from "react-chartjs-2";
import Chart from 'chart.js/auto'; //지우면 안됨 category 에러

/**
 * 시간 인터벌 메서드
 * @param callback
 * @param delay
 */
function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            const intervalId = setInterval(tick, delay);
            return () => clearInterval(intervalId);
        }
    }, [delay]);
}


/**
 * 대시보드 화면
 * @param callback
 * @param delay
 */
function Dashboard({setMovePage}) {

    const [loading, setLoading] = useState(false);
    const [dashTopData, setDashTopData] = useState({
        serviceCnt: 0, identityUserCnt: 0, totalAccess: 0, totalExpire:0
    }); //사용자 통계
    const [tokenChartData, setTokenChartData] = useState(null); //액세스토큰 24시간 그래프
    const [ServiceUsersChartdata, setServiceUsersChartdata] = useState(null); //서비스유저 통계

    useEffect(() => {
        setMovePage("dashboard");
        fetchTotalUserData();
        fetchToeknChartData();
        fetchServiceUserChartData();
    }, []);

    // delay 초마다 데이터 fetching
    useInterval(() => {
        fetchToeknChartData();
        fetchServiceUserChartData();
    }, 10 * 60 * 1000);

    // //사용자 통계 조회 API 
    const fetchTotalUserData = () => {
        const url = IAM_SERVER_DASHBOARD + "/admin/statistics";
        axios.get(url)
            .then((res) => {
                setDashTopData(res.data.data);
            })
            .catch((e) => {
            })
            .finally(() => {
                setLoading(false);
            })
    }

    // 토큰 액세스 24시간 통계 조회 API 
    const fetchToeknChartData = async () => {
        const tokenUrl = IAM_SERVER_DASHBOARD + "/last24hours/service?serviceId=IAM&actionType=OAAS0300";
        setTokenChartData(null);
        axios.get(tokenUrl)
            .then(res => {
                processToekenChartData(res.data.data);
            })
            .catch(err => {
            })
            .finally(() => {
                setLoading(false);
            })
    }

    // 서비스 유저 통계 조회 API
    const fetchServiceUserChartData = async () => {
        setLoading(true);
        const userUrl = IAM_SERVER_DASHBOARD + "/admin/serviceUserCount";
        setServiceUsersChartdata(null);
        axios.get(userUrl)
            .then(res => {
                processServiceUsersChartData(res.data.data);
            })
            .catch(err => {
            })
            .finally(() => {
                setLoading(false);
            })
    }

    // // 사용자 로그인 통계 조회 API Response Data 처리
    const processToekenChartData = (data) => {
        try {
            const labelArray = [];
            const countArray = [];
        for (const chartData of data) {
            // statDate에서 시각만 추출 ("2025-06-04T01:00:00.000+00:00" → "01:00")
            // ISO 형식이 아니라면 new Date()로 변환 후 getHours() 사용
            const date = new Date(chartData.id.statDate);
            const hour = date.getHours().toString().padStart(2, "0");
            labelArray.push(`${hour}:00`);
            countArray.push(chartData.cnt);
        }

            const graphData = {
                labels: labelArray.length === 0 ? [] : labelArray,
                datasets: [{
                    label: '액세스 토큰 통계',
                    data: countArray ?? [],
                }]
            }

            setTokenChartData(graphData);
        } catch (e) {
        }
    }

    // 서비스 유저 통계 조회 API Response Data 처리
    const processServiceUsersChartData = (data) => {
        const labelArray = [];
        const countArray = [];
        for (const chartData of data) {
            labelArray.push(chartData.linkServiceId);
            countArray.push(chartData.userCount);
        }

        const graphData = {
            labels: labelArray.length === 0 ? [] : labelArray,
            datasets: [{
                label: '서비스 사용자 통계',
                data: countArray ?? [],
            }]
        }

        setServiceUsersChartdata(graphData);
    }

    // // 그래프 options
    const options = {
        responsive: true, // 그래프 크기를 브라우저 크기에 맞게 조정
        maintainAspectRatio: false, //부모요소 크기에 맞춤
        y: {
            beginAtZero: true, // Y축 눈금이 0에서 시작하도록 설정
            ticks: {
                stepSize: 10, // Y축 눈금 간격 설정
            },
        },
        plugins: {
            legend: {
                display: false, // 레이블 숨기기 (기본값은 true)
            },
        },
    };

    return (
        <>
            {loading ? <Loading/> :
                <div className={"rightCont__cont"}>

                    <div className={styles.rightCont__cont__situTop}>
                        <div className={`${styles.rightCont__cont__situBox} ${styles.totalUser}`}>
                            <p className={styles.rightCont__cont__cate}>전체 서비스 수</p>
                            <h3 className={`${styles.rightCont__cont__count} ${styles.totalUser}`}>{dashTopData.serviceCnt}</h3>
                        </div>
                        <div className={`${styles.rightCont__cont__situBox} ${styles.totalReg}`}>
                            <p className={styles.rightCont__cont__cate}>전체 사용자 수</p>
                            <h3 className={`${styles.rightCont__cont__count} ${styles.totalReg}`}>{dashTopData.identityUserCnt}</h3>
                        </div>
                        <div className={`${styles.rightCont__cont__situBox} ${styles.totalUnReg}`}>
                            <p className={styles.rightCont__cont__cate}>하루 발급 현황 (발급/만료)</p>
                            <h3 className={`${styles.rightCont__cont__count} ${styles.totalUnReg}`}>{dashTopData.totalAccess}/{dashTopData.totalExpire}</h3>
                        </div>
                    </div>

                    <div className={styles.rightCont__cont__dash}>
                        <ul className={styles.rightCont__cont__dashList}>
                            <li className={styles.rightCont__cont__list}>
                                <div className={styles.rightCont__cont__listDesc}>
                                    <span className={styles.rightCont__cont__listTit}>서비스 유저 통계</span>
                                </div>
                                <div className={styles.rightCont__cont__listDetail}>
                                    {loading ? <CircularProgress/> :
                                        <>
                                            {ServiceUsersChartdata === null ?
                                                // <div className={styles.rightCont__cont__listDetail__circular}><CircularProgress/></div>
                                                <div className={styles.rightCont__cont__listDetail__circular}>데이터 조회에 실패했습니다.</div>
                                                :
                                                <Doughnut data={ServiceUsersChartdata} options={options}/>
                                            }
                                        </>
                                    }
                                </div>
                            </li> 
                            <li className={styles.rightCont__cont__list}>
                                <div className={styles.rightCont__cont__listDesc}>
                                    <span className={styles.rightCont__cont__listTit}>사용자 로그인 통계</span>
                                </div>
                                <div className={styles.rightCont__cont__listDetail}>
                                    {tokenChartData === null ?
                                        <div className={styles.rightCont__cont__listDetail__circular}>데이터 조회에 실패했습니다.</div>
                                        :
                                        <Line data={tokenChartData} options={options}/>
                                    }
                                </div>
                            </li>
                        </ul>
                    </div> 


                </div>
            }        
        </>
    )
}

export default Dashboard;
